// Checked

import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import user5up from "../../../assets/images/user5up.svg";
import lockIcon from "../../../assets/images/lockIcon.svg";
// import Button from "@material-ui/core/Button";
// import { useHistory } from "react-router-dom";
import ProfileSettings from "./ProfileSettings";
import PasswordSettings from "./PasswordSettings";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    marginBottom: "40px",
  },
  rootChildStyle: {
    padding: "30px 20px",
  },
  borderStyle: {
    borderRight: "2px solid rgba(0, 0, 0, .05)",
  },

  title: {
    marginBottom: 20,
  },
  marginRightStyle: {
    marginRight: 15,
  },
  marginRightStyle2: {
    marginRight: 19,
  },
  listItemStyle: {
    cursor:'pointer',
    padding: "10px 15px",
    marginBottom: "10px",
    borderRadius: "8px",
    "&:hover": {
      background: "rgba(156, 56, 54, 0.12)",
    },
  },
  active: {
    cursor:'pointer',
    padding: "10px 15px",
    background: "rgba(156, 56, 54, 0.2)",
    marginBottom: "10px",
    borderRadius: "8px",
    "&:hover": {
      background: "rgba(156, 56, 54, 0.2)",
    },
  },
  menuFontStyle: {
    fontSize: 16,
    color: "#474645",
    marginLeft: 10,
    cursor:'pointer',
  },
}));

const AccountSettings = () => {
  const classes = useStyles();
  const [active, setActive] = useState("ProfileSettings");

  return (
    <>
      <Typography variant="h4" className={classes.title}>
        Account Settings
      </Typography>
      <div className={classes.root}>
        <Grid container>
          <Grid
            item
            xs={4}
            className={`${classes.rootChildStyle} ${classes.borderStyle}`}
          >
            <Grid
              container
              alignItems="center"
              className={
                active === "ProfileSettings"
                  ? classes.active
                  : classes.listItemStyle
              }
              onClick={() => setActive("ProfileSettings")}
            >
              <img src={user5up} alt="" className={classes.marginRightStyle} />{" "}
              <label className={classes.menuFontStyle}>Profile Settings</label>
            </Grid>
            <Grid
              container
              alignItems="center"
              className={
                active === "PasswordSettings"
                  ? classes.active
                  : classes.listItemStyle
              }
              onClick={() => setActive("PasswordSettings")}
            >
              <img
                src={lockIcon}
                alt=""
                className={classes.marginRightStyle2}
              />
              <label className={classes.menuFontStyle}>
                {" "}
                Password Settings
              </label>
            </Grid>
          </Grid>
          <Grid item xs={8} className={classes.rootChildStyle}>
            {active === "ProfileSettings" && <ProfileSettings />}
            {active === "PasswordSettings" && <PasswordSettings />}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AccountSettings;
